import { grey } from "@mui/material/colors";
import type { SxProps, Theme } from "@mui/material/styles";

import { misc, neutral } from "app/themes/colors";

/**
 * Shared styles for expand/collapse IconButtons (billing sale rows, filter modal, etc.).
 */
export function getExpandToggleIconButtonSx(
  theme: Theme,
  extraSx?: SxProps
): SxProps {
  return {
    cursor: "pointer",
    border: `solid 1px ${neutral[300]}`,
    boxShadow: theme.shadows[1],
    background: grey[100],
    "&:active": {
      color: misc.blackAsphalt
    },
    "&:hover": {
      background: grey[500],
      color: "white"
    },
    transform: "scale(0.9)",
    color: misc.blackAsphalt,
    flexShrink: 0,
    ...extraSx
  };
}
